import { useState } from 'react'

const FAQS = [
  {
    q: 'How does an online consultation work?',
    a: "After booking, you'll receive a video/audio call link along with a reminder 30 minutes before your slot. Share your birth date, time and place in advance so your chart is ready.",
  },
  {
    q: 'Can I reschedule my booking?',
    a: 'Yes, you can reschedule up to 4 hours before your slot from the "My Bookings" section, free of charge.',
  },
  {
    q: 'What should I have ready before the session?',
    a: 'Your exact date, time and place of birth. If you have a previous Kundli or chart, keep it handy — it helps speed up the reading.',
  },
]

export default function AstrologerFaqSection() {
  const [openIndex, setOpenIndex] = useState(0)

  return (
    <div className="info-card p-6 sm:p-8 space-y-4">
      <h2 className="text-xl font-cinzel text-[#1C140A]">Frequently asked questions</h2>
      <div className="divide-y divide-[#D7C29A]/20">
        {FAQS.map((item, i) => {
          const isOpen = openIndex === i
          return (
            <div key={item.q} className="py-4">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="w-full flex items-center justify-between gap-4 text-left"
                aria-expanded={isOpen}
              >
                <span className="text-sm font-semibold text-[#1C140A]">{item.q}</span>
                <svg
                  className="w-3.5 h-3.5 text-secondary shrink-0 transition-transform duration-300"
                  style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div
                className="grid transition-[grid-template-rows] duration-300 ease-out"
                style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
              >
                <div className="overflow-hidden">
                  <p className="pt-3 text-sm leading-relaxed text-[#5C3A18]">{item.a}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
